import { FaHome } from 'react-icons/fa';
import { BsTable } from 'react-icons/bs';
import { MdSupervisorAccount, MdAdd } from 'react-icons/md';

export const pageList = [
  {
    path: '/teacket',
    label: 'Home',
    icon: <FaHome />,
    permissions: ['apps.teacket.view'],
  },
  {
    path: '/teacket/create-new',
    label: 'Create new',
    icon: <MdAdd />,
    permissions: ['apps.teacket.view'],
  },
  {
    path: '/teacket/tickets',
    label: 'Ticket List',
    icon: <BsTable />,
    permissions: ['apps.teacket.view'],
  },
  {
    path: '/teacket/supervisor',
    label: 'Supervisor',
    icon: <MdSupervisorAccount />,
    permissions: ['apps.teacket.view'],
  },
];
